// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.history-popover,
.history-popover-scroller {
    /* Remove any legacy width:100% that may cause stretching */
    width: auto;
    font-size: 0.75rem;
    background: #fff;
    max-width: calc(100vw - 40px);
    box-sizing: border-box;
    border: 1px solid #d6d6d6;
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.history-popover-fullwidth {
    /* Subtle elevation look */
    box-shadow: 0 2px 4px rgba(0,0,0,0.08);
}

.history-popover-fullrow {
    padding: 0;
}

.history-popover-scroller {
    /* If you sometimes want horizontal scroll for very wide tables */
    overflow-x: auto;
}

    .history-popover .table,
    .history-popover-scroller .table {
        margin-bottom: 0.55rem;
        background: transparent;
    }

.history-popover-header {
    font-weight: 600;
    font-size: 1rem;
    padding: 0.75rem 1.1rem;
    background: #f8f8f9;
    border-bottom: 1px solid #e2e2e2;
    color: #333;
    margin: 0;
}

.history-popover-body {
    /* Keep table tight */
    padding: 0.8rem 1.1rem 1rem 1.1rem;
    display: flex;
    flex: 1 1 auto;
    overflow: hidden;
}

.history-popover-fit-cell {
    /* Ensure it cannot exceed the cell width */
    width: 100% !important;
    max-width: 100% !important;
    box-sizing: border-box;
}

    .history-popover-fit-cell .history-popover-body {
        overflow-x: auto;
    }

.history-trigger-wrapper {
    display: inline-block;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;
    cursor: pointer;
}

.history-popover .popover-header,
.history-popover-scroller .popover-header {
    font-weight: 600;
    font-size: 0.9rem;
}

.history-inner-scroll {
    width: 100%;
    overflow-x: auto;
    overflow-y: auto;
}

    .history-inner-scroll.fullwidth {
        /* Keep table readable without forcing page scroll */
        max-height: 100%;
    }

    .history-inner-scroll .table {
        min-width: 780px;
        margin-bottom: 0;
        table-layout: fixed;
    }

        .history-inner-scroll .table th,
        .history-inner-scroll .table td {
            white-space: nowrap;
            padding: 0.3rem 0.5rem;
            font-size: 0.67rem;
        }

.history-popover .loading,
.history-popover-body > div:only-child:empty::before {
    content: "Loading...";
    display: block;
    padding: 0.25rem;
    font-style: italic;
    color: #444;
}

.history-fullrow-table-wrapper {
    width: 100%;
}

.history-popover .table thead th {
    background: #eceeef;
    border-color: #d5d5d5;
    font-weight: 600;
    white-space: nowrap;
    font-size: 0.78rem;
    padding: 0.45rem 0.6rem;
}

.history-popover .table tbody td {
    font-size: 0.75rem;
    padding: 0.42rem 0.6rem;
    white-space: nowrap;
    vertical-align: middle;
    border-color: #e1e1e1;
}

.history-popover .history-popover-body p,
.history-popover .history-popover-body div {
    margin: 0;
}

.history-popover .popover-arrow,
.popover .popover-arrow {
    display: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/Shared/HistoryPopover.css"],"names":[],"mappings":"AAAA;;IAEI,2DAA2D;IAC3D,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,6BAA6B;IAC7B,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,sCAAsC;AAC1C;;AAEA;IACI,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iEAAiE;IACjE,gBAAgB;AACpB;;IAEI;;QAEI,sBAAsB;QACtB,uBAAuB;IAC3B;;AAEJ;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,gCAAgC;IAChC,WAAW;IACX,SAAS;AACb;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;IAC3C,sBAAsB;IACtB,0BAA0B;IAC1B,sBAAsB;AAC1B;;IAEI;QACI,gBAAgB;IACpB;;AAEJ;IACI,qBAAqB;IACrB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;;IAEI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;IAEI;QACI,oDAAoD;QACpD,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,mBAAmB;IACvB;;QAEI;;YAEI,mBAAmB;YACnB,sBAAsB;YACtB,kBAAkB;QACtB;;AAER;;IAEI,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;;IAEI,SAAS;AACb;;AAEA;;IAEI,wBAAwB;AAC5B","sourcesContent":[".history-popover,\r\n.history-popover-scroller {\r\n    /* Remove any legacy width:100% that may cause stretching */\r\n    width: auto;\r\n    font-size: 0.75rem;\r\n    background: #fff;\r\n    max-width: calc(100vw - 40px);\r\n    box-sizing: border-box;\r\n    border: 1px solid #d6d6d6;\r\n    border-radius: 4px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.08);\r\n}\r\n\r\n.history-popover-fullwidth {\r\n    /* Subtle elevation look */\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.08);\r\n}\r\n\r\n.history-popover-fullrow {\r\n    padding: 0;\r\n}\r\n\r\n.history-popover-scroller {\r\n    /* If you sometimes want horizontal scroll for very wide tables */\r\n    overflow-x: auto;\r\n}\r\n\r\n    .history-popover .table,\r\n    .history-popover-scroller .table {\r\n        margin-bottom: 0.55rem;\r\n        background: transparent;\r\n    }\r\n\r\n.history-popover-header {\r\n    font-weight: 600;\r\n    font-size: 1rem;\r\n    padding: 0.75rem 1.1rem;\r\n    background: #f8f8f9;\r\n    border-bottom: 1px solid #e2e2e2;\r\n    color: #333;\r\n    margin: 0;\r\n}\r\n\r\n.history-popover-body {\r\n    /* Keep table tight */\r\n    padding: 0.8rem 1.1rem 1rem 1.1rem;\r\n    display: flex;\r\n    flex: 1 1 auto;\r\n    overflow: hidden;\r\n}\r\n\r\n.history-popover-fit-cell {\r\n    /* Ensure it cannot exceed the cell width */\r\n    width: 100% !important;\r\n    max-width: 100% !important;\r\n    box-sizing: border-box;\r\n}\r\n\r\n    .history-popover-fit-cell .history-popover-body {\r\n        overflow-x: auto;\r\n    }\r\n\r\n.history-trigger-wrapper {\r\n    display: inline-block;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 100%;\r\n    text-align: center;\r\n    cursor: pointer;\r\n}\r\n\r\n.history-popover .popover-header,\r\n.history-popover-scroller .popover-header {\r\n    font-weight: 600;\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.history-inner-scroll {\r\n    width: 100%;\r\n    overflow-x: auto;\r\n    overflow-y: auto;\r\n}\r\n\r\n    .history-inner-scroll.fullwidth {\r\n        /* Keep table readable without forcing page scroll */\r\n        max-height: 100%;\r\n    }\r\n\r\n    .history-inner-scroll .table {\r\n        min-width: 780px;\r\n        margin-bottom: 0;\r\n        table-layout: fixed;\r\n    }\r\n\r\n        .history-inner-scroll .table th,\r\n        .history-inner-scroll .table td {\r\n            white-space: nowrap;\r\n            padding: 0.3rem 0.5rem;\r\n            font-size: 0.67rem;\r\n        }\r\n\r\n.history-popover .loading,\r\n.history-popover-body > div:only-child:empty::before {\r\n    content: \"Loading...\";\r\n    display: block;\r\n    padding: 0.25rem;\r\n    font-style: italic;\r\n    color: #444;\r\n}\r\n\r\n.history-fullrow-table-wrapper {\r\n    width: 100%;\r\n}\r\n\r\n.history-popover .table thead th {\r\n    background: #eceeef;\r\n    border-color: #d5d5d5;\r\n    font-weight: 600;\r\n    white-space: nowrap;\r\n    font-size: 0.78rem;\r\n    padding: 0.45rem 0.6rem;\r\n}\r\n\r\n.history-popover .table tbody td {\r\n    font-size: 0.75rem;\r\n    padding: 0.42rem 0.6rem;\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    border-color: #e1e1e1;\r\n}\r\n\r\n.history-popover .history-popover-body p,\r\n.history-popover .history-popover-body div {\r\n    margin: 0;\r\n}\r\n\r\n.history-popover .popover-arrow,\r\n.popover .popover-arrow {\r\n    display: none !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
